export default "__VITE_ASSET__941852a7__"